import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Parser } from '../../common'

const ListOfSituations = ({ block }) => {
    const buttonRefs = useRef({})
    const [selectedSituations, setSelectedSituations] = useState(null)

    const getFilteredSituationBlock = useCallback((filterBlockSelected) => {
        switch (filterBlockSelected.block) {
            case 'Cas':
            case 'Situation':
                return filterBlockSelected.childrens.filter((child) => child?.block !== 'Titre')
            default:
                return filterBlockSelected.childrens.find((child) => child?.block !== 'Titre')
                    .childrens
        }
    }, [])

    const blockSituationSelected = useCallback(() => {
        const filterBlockSelected = block?.childrens.find(
            (child) => child?.attributes?.id === selectedSituations
        )

        if (!filterBlockSelected) return []

        return getFilteredSituationBlock(filterBlockSelected) || []
    }, [selectedSituations, block?.childrens, getFilteredSituationBlock])

    const handleButtonClick = (id) => {
        setSelectedSituations(id)
        buttonRefs.current[id].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
        })
    }

    useEffect(() => {
        setSelectedSituations(block?.childrens[0].attributes?.id)
    }, [block])

    return block?.childrens?.length > 1 ? (
        <div className="baseocom-list-of-situations">
            <ul>
                {block?.attributes?.elements?.map((tab, index) => (
                    <li key={index}>
                        <button
                            ref={(el) => (buttonRefs.current[tab?.id] = el)}
                            onClick={() => handleButtonClick(tab?.id)}
                            key={tab?.id}
                            className={`${selectedSituations === tab?.id ? 'situation-selected' : 'situations-not-selected'} `}
                        >
                            {tab?.title}
                        </button>
                    </li>
                ))}
            </ul>
            <div>
                <div>
                    <Parser content_block={blockSituationSelected()} />
                </div>
            </div>
        </div>
    ) : (
        <div>
            <Parser content_block={blockSituationSelected()} />
        </div>
    )
}

export default ListOfSituations
